module.exports = __webpack_public_path__ + "img/xiTong.5e53403b.svg";